const canScheduleInitialAssessment = ({ scheduleEvents }) => {
  return !scheduleEvents.some((e) => e.type === "INITIAL_ASSESSMENT");
};

const canScheduleFinalAssessment = ({ scheduleEvents }) => {
  return !scheduleEvents.some(
    (e) => e.type === "FINAL_ASSESSMENT" && e.attended !== false
  );
};

const baseAssessmentRules = {
  QUIZ_ANSWERED: {
    type: "INITIAL_ASSESSMENT",
    uploadFiles: true,
    showForm: true,
  },
  ASSESSMENT_NO_SHOW: {
    type: "INITIAL_ASSESSMENT",
    uploadFiles: true,
    showForm: true,
  },
  ASSESSMENT_MADE_RESCHEDULE: {
    type: "INITIAL_ASSESSMENT",
    uploadFiles: true,
    showForm: true,
  },
  SCHEDULED_ASSESSMENT: {
    type: "INITIAL_ASSESSMENT",
    uploadFiles: false,
    showForm: canScheduleInitialAssessment,
  },
  QUIZ_SATISFACTION_ANSWERED: {
    type: "FINAL_ASSESSMENT",
    uploadFiles: false,
    showForm: canScheduleFinalAssessment,
  },
};

export const rulesForTPatientSurgeryAssessment = {
  HYPERBARIC_FLOW_NOX: {
    "NO RED FLAG": baseAssessmentRules,
    "RED FLAG": baseAssessmentRules,
  },
  CORE_NOX: {
    "FAST TRACK": baseAssessmentRules,
    "SLOW TRACK": baseAssessmentRules,
  },
  CORE_SOGAMOSO: {
    "FAST TRACK": baseAssessmentRules,
    "SLOW TRACK": baseAssessmentRules,
  },
};
